import { render, staticRenderFns } from "./UICloseLayer.vue?vue&type=template&id=098a3eed&"
import script from "./UICloseLayer.vue?vue&type=script&lang=js&"
export * from "./UICloseLayer.vue?vue&type=script&lang=js&"
import style0 from "./UICloseLayer.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports